import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { getDeviationById } from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import { getCompositeId } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/deviation';
import { DeviationResourceType } from '@wix/da-shared-react/pkg/types/deviation';
import { selectors } from '@wix/da-shared-react/pkg/Stream';
import { AppState } from '../../../../types/store';
import {
  getProfileOwnerUser,
  isCurrentUserProfileOwner,
} from '../../../selectors/users';
import {
  getSelectedTierId,
  getSelectedTierContentType,
} from '../../../selectors/subscriptionsSection';
import {
  getTierContentDeviationsStreamId,
} from '../../../streams/tierContent';
import { setSelectedTierContentType } from '../../../actions/subscriptionsSection';
import { SubscriptionsTierContentType } from '../../../../types/subscriptionsSection';
import { Props } from './TierContent';

type StateProps = Pick<
  Props,
  | 'tier'
  | 'selectedTierContentType'
  | 'isOwner'
  | 'isEmpty'
  | 'streamId'
  | 'profileOwner'
>;
type DispatchProps = Pick<Props, 'setSelectedTierContentType'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  const selectedTierId = getSelectedTierId(state);
  const selectedTierContentType =
    getSelectedTierContentType(state) ||
    SubscriptionsTierContentType.DEVIATIONS;
  const tier =
    selectedTierId &&
    getDeviationById(
      state,
      getCompositeId(DeviationResourceType.TIER, selectedTierId)
    );
  const streamId = getTierContentDeviationsStreamId(
    tier ? tier.deviationId : 0,
    selectedTierContentType
  );
  return {
    tier: tier || undefined,
    isOwner: isCurrentUserProfileOwner(state),
    profileOwner: getProfileOwnerUser(state),
    isEmpty: (selectors.getItems(state, streamId) || []).length === 0,
    streamId,
    selectedTierContentType,
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  setSelectedTierContentType,
};

export default connect(mapStateToProps, mapDispatchToProps);
